/**
* 风控首页
*/
<template>
	<div style="display: flex;flex-direction: column; height: 92vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div
			style="margin-bottom: 10px; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05); border: 1px solid #ebeef5; background: #fff; flex-shrink: 0;">

			<div @click="showStats = !showStats"
				style="display: flex; align-items: center; justify-content: space-between; padding: 12px 20px; background: #fafafa; border-bottom: 1px solid #f0f2f5; cursor: pointer; user-select: none;">
				<div style="display: flex; align-items: center;">
					<div style="width: 4px; height: 14px; background: #409EFF; border-radius: 2px; margin-right: 8px;">
					</div>
					<span style="font-size: 13px; font-weight: bold; color: #606266;">风控数据总览</span>
					<i :class="showStats ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
						style="margin-left: 8px; color: #909399; font-size: 12px;"></i>
				</div>
				<div style="font-size: 12px; color: #999;">{{ showStats ? '点击收起面板' : '点击展开统计' }}</div>
			</div>

			<el-collapse-transition>
				<div v-show="showStats"
					style="display: flex; background: #ffffff; padding: 20px; gap: 16px; border-bottom: 1px solid #f0f2f5;">
					<div v-for="(item, index) in statList" :key="index" @click="item.action ? item.action() : null"
						:style="{
					        flex: '1',
					        position: 'relative',
					        display: 'flex',
					        alignItems: 'center',
					        padding: '18px 20px',
					        borderRadius: '12px',
					        background: item.bgColor,
					        borderLeft: '5px solid ' + item.color,
					        boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
					        cursor: item.action ? 'pointer' : 'default',
					        transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
					        overflow: 'hidden'
					     }" onmouseover="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 8px 20px rgba(0,0,0,0.08)'"
						onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 6px rgba(0,0,0,0.04)'">
						<div style="flex: 1; z-index: 2;">
							<div
								style="font-size: 11px; letter-spacing: 1.2px; font-weight: 700; color: #94a3b8; margin-bottom: 4px; text-transform: uppercase;">
								{{ item.enTitle }}
							</div>

							<div style="font-size: 26px; font-weight: 800; color: #1e293b; line-height: 1.2;">
								{{ item.value }}
							</div>

							<div style="margin-top: 10px; font-size: 12px; font-weight: 600;">
								<el-link v-if="item.action" :underline="false"
									:style="{ color: item.color, fontSize: '12px' }">
									{{ item.cnTitle }} <i class="el-icon-right" style="margin-left: 4px;"></i>
								</el-link>
								<span v-else :style="{ color: item.color }">{{ item.cnTitle }}</span>
							</div>
						</div>

						<i :class="[item.icon]" :style="{ 
					          fontSize: '56px', 
					          color: item.color, 
					          opacity: '0.12', 
					          position: 'absolute', 
					          right: '-8px', 
					          bottom: '-8px',
					          transform: 'rotate(-15deg)'
					       }">
						</i>
					</div>
				</div>
			</el-collapse-transition>

			<div @click="showSearch = !showSearch"
				style="display: flex; align-items: center; justify-content: space-between; padding: 12px 20px; background: #fafafa; border-bottom: 1px solid #f0f2f5; cursor: pointer; user-select: none;">
				<div style="display: flex; align-items: center;">
					<div style="width: 4px; height: 14px; background: #67C23A; border-radius: 2px; margin-right: 8px;">
					</div>
					<span style="font-size: 13px; font-weight: bold; color: #606266;">条件筛选查询</span>
					<i :class="showSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
						style="margin-left: 8px; color: #909399; font-size: 12px;"></i>
				</div>
				<div style="font-size: 11px; color: #999;">{{ showSearch ? '收起搜索项' : '展开搜索项' }}</div>
			</div>


			<el-collapse-transition>
				<div v-show="showSearch" style="padding: 16px 20px; background: #ffffff;">

					<!-- 搜索条件 -->
					<el-form :inline="true" size="mini" label-position="left" style="margin-bottom: -10px;">

						<el-form-item label="搜索时间" style="margin-bottom: 12px; margin-right: 20px;">
							<el-date-picker v-model="value" type="daterange" @change="selectTime" start-placeholder="开始"
								end-placeholder="结束" :default-time="['00:00:00', '23:59:59']"
								style="width: 240px; border-radius: 4px;">
							</el-date-picker>
						</el-form-item>

						<el-form-item label="序列号" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="序列号" v-model="input1" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="设备ID" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="设备ID" v-model="input2" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="IP地址" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="IP地址" v-model="input7" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="IP属地" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="IP属地" v-model="input8" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="用户ID" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="用户ID" v-model="input3" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="昵称" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="昵称" v-model="input4" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="手机号" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="手机号" v-model="input5" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="品牌" style="margin-bottom: 12px; margin-right: 20px;">
							<el-input placeholder="品牌" v-model="input6" style="width: 240px;" clearable></el-input>
						</el-form-item>

						<el-form-item label="风险等级" style="margin-bottom: 12px; margin-right: 20px;">
							<el-select v-model="input9" placeholder="全部等级" style="width: 240px;" clearable>
								<el-option v-for="item in riskOptions" :key="item.value" :label="item.label"
									:value="item.value">
									<span style="display: flex; align-items: center; gap: 8px;">
										<i :style="{
						                    width: '8px', 
						                    height: '8px', 
						                    borderRadius: '50%', 
						                    background: item.color,
						                    display: 'inline-block'
						                }"></i>
										<span style="font-size: 13px;">{{ item.label }}</span>
									</span>
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item style="margin-bottom: 12px; margin-left: auto; float: right;">
							<el-button type="primary" icon="el-icon-search" @click="search()"
								style="box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);">查询</el-button>
							<el-button icon="el-icon-refresh-right" @click="reset()">重置</el-button>
						</el-form-item>
						<div style="clear: both;"></div>
					</el-form>
				</div>
			</el-collapse-transition>
		</div>


		<!-- 列表 -->
		<el-table :data="tableData" height="100%" stripe border :header-cell-style="{ 
		        background: '#f8f9fa', 
		        color: '#303133', 
		        fontWeight: 'bold', 
		        fontSize: '14px',
		        height: '50px'
		    }" :cell-style="{ fontSize: '14px', color: '#606266', padding: '12px 0' }"
			style="width: 100%; flex: 1; border-radius: 4px;"
			:default-sort="{ prop: 'loginTime', order: 'descending' }">

			<el-table-column type="index" :index="indexMethod" label="序号" width="60" align="center"></el-table-column>

			<el-table-column label="登录记录 / 序列号" min-width="180">
				<template slot-scope="scope">
					<div style="color: #303133;">{{ scope.row.loginTime }}</div>
					<div
						style="font-family: Consolas, Monaco, monospace; font-size: 12px; color: #909399; word-break: break-all;">
						序列号: {{ scope.row.sequenceId }}
					</div>
				</template>
			</el-table-column>


			<el-table-column label="用户信息" width="160">
				<template slot-scope="scope">
					<div style="line-height: 1.4; padding: 2px 0;">

						<div :style="{ 
			                fontSize: '14px', 
			                fontWeight: '600',
			                color: scope.row.nickName ? '#409EFF' : '#C0C4CC',
			                whiteSpace: 'nowrap',
			                overflow: 'hidden',
			                textOverflow: 'ellipsis'
			            }">
							{{ scope.row.nickName || '--' }}
						</div>

						<div style="font-size: 11px; color: #99a9bf; display: flex; align-items: center; gap: 4px;">
							<span style="color: #909399;">ID</span>
							<span style="font-size: 12px; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;">
								{{ scope.row.userId }}
							</span>
						</div>

					</div>
				</template>
			</el-table-column>

			<el-table-column label="设备ID" prop="deviceId" width="180">
				<template slot-scope="scope">
					<span
						style="font-family: Consolas, Monaco, monospace; font-size: 12px;">{{ scope.row.deviceId }}</span>
				</template>
			</el-table-column>

			<el-table-column label="终端设备" width="140" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center; justify-content: center; gap: 2px;">

						<div v-if="scope.row.deviceOs"
							style="display: flex; align-items: center; justify-content: center;">
							<svg v-if="scope.row.deviceOs && scope.row.deviceOs.toLowerCase().includes('ios')"
								viewBox="0 0 1024 1024" width="16" height="16" style="vertical-align: middle;">
								<path
									d="M720.2 461c-1.4-101.1 82.8-149.7 86.6-152.1-47.1-68.9-120.4-78.3-146.5-79.4-62.5-6.4-121.9 36.8-153.6 36.8-31.7 0-80.4-36-132.5-35-68.5 1-131.6 39.9-166.8 101.1-71.2 123.6-18.2 306.7 50.8 406.4 33.8 48.8 74.1 103.6 126.9 101.7 50.8-1.9 70-32.7 131.4-32.7 61.3 0 78.5 32.7 132.5 31.7 55-1 91.4-49.8 125-98.6 38.7-56.3 54.7-110.8 55.6-113.7-1.3-0.4-107.5-41.2-109.4-165.2z"
									fill="none" stroke="#606266" stroke-width="50" stroke-linejoin="round"></path>
								<path
									d="M616.4 205.1c28-33.9 46.9-81 41.7-128.1-40.4 1.6-89.4 26.9-118.4 60.8-26 30.1-48.8 78.7-42.7 124.5 45.2 3.5 91.4-23.3 119.4-57.2z"
									fill="none" stroke="#606266" stroke-width="50" stroke-linejoin="round"></path>
							</svg>

							<svg v-else-if="scope.row.deviceOs && scope.row.deviceOs.toLowerCase().includes('android')"
								viewBox="0 0 1024 1024" width="17" height="17">
								<path
									d="M704 64H320c-53 0-96 43-96 96v704c0 53 43 96 96 96h384c53 0 96-43 96-96V160c0-53-43-96-96-96zM320 128h384c17.7 0 32 14.3 32 32v48H288v-48c0-17.7 14.3-32 32-32z m384 768H320c-17.7 0-32-14.3-32-32v-48h448v48c0 17.7-14.3 32-32 32z m32-144H288V272h448v480z"
									fill="#A4C639"></path>
							</svg>

							<i v-else class="el-icon-mobile-phone" style="color: #909399;"></i>
						</div>


						<div style="display: flex; align-items: center; white-space: nowrap;">
							<span v-if="scope.row.brand" style="font-size: 12px; color: #909399; font-weight: 400;">
								{{ scope.row.brand }}
							</span>
							<span v-else style="color: #C0C4CC; font-size: 12px;">未知设备</span>
						</div>
					</div>
				</template>
			</el-table-column>

			<el-table-column label="风险评估 (网易/AI)" width="160" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center; justify-content: center; gap: 6px;">
						<span :style="{ 
						    fontSize: '13px', 
						    fontWeight: '500',
						    /* 逻辑：风险越高，颜色越亮、越深 */
						    color: scope.row.riskLevel === '高风险' ? '#F56C6C' :           // 红色 (警示)
						          (scope.row.riskLevel === '中风险' ? '#E6A23C' :           // 橙色 (注意)
						          (scope.row.riskLevel === '低风险' ? '#409EFF' :           // 蓝色 (提示：比正常更明显)
						          (scope.row.riskLevel === '正常' ? '#C0C4CC' : '#909399'))) // 浅灰色 (忽略：最不显眼)
						}">
							{{ scope.row.riskLevel }}
						</span>

						<span style="color: #EBEEF5;">|</span>

						<el-tag size="mini" :type="getType(scope.row.aiRiskLevel)" effect="plain"
							style="border: none; padding: 0; background: transparent; font-weight: bold; font-size: 13px;">
							<i :class="getIcon(scope.row.aiRiskLevel)" style="margin-right: 2px;"></i>
							{{ getText(scope.row.aiRiskLevel) }}
						</el-tag>
					</div>
				</template>
			</el-table-column>

			<el-table-column label="状态 / 白名单" width="120" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center; justify-content: center; gap: 8px;">

						<span :style="{ 
			                fontSize: '12px',
			                fontWeight: scope.row.status === '正常' ? '400' : '600',
			                color: {
			                    '正常': '#C0C4CC',     // 浅灰
			                    '自己注销': '#909399', // 中灰
			                    '禁言': '#E6A23C',     // 橙色
			                    '被封禁': '#F56C6C',   // 红色
			                    '禁止登录': '#F56C6C', // 红色
			                    '自动封号': '#AF292E'  // 深红
			                }[scope.row.status] || '#909399'
			            }">
							{{ scope.row.status }}
						</span>

						<span style="color: #EBEEF5;">|</span>

						<span :style="{
						    fontSize: '12px',
						    padding: '2px 6px',
						    borderRadius: '4px',
						    whiteSpace: 'nowrap',
						    /* 1 (是): 绿底绿字有边框，非常显眼 */
						    background: scope.row.isWhiteList === 1 ? '#F0F9EB' : 'transparent',
						    /* 0 (否): 使用 #C0C4CC，确保和账号状态的‘正常’颜色完全对齐 */
						    color: scope.row.isWhiteList === 1 ? '#67C23A' : '#C0C4CC', 
						    border: scope.row.isWhiteList === 1 ? '1px solid #E1F3D8' : '1px solid transparent',
						    /* ‘否’的时候不需要加粗，‘是’的时候可以加粗增强对比 */
						    fontWeight: scope.row.isWhiteList === 1 ? '600' : '400'
						}">
							{{ scope.row.isWhiteList === 1 ? '是' : '否' }}
						</span>

					</div>
				</template>
			</el-table-column>


			<el-table-column label="手机号" width="130" align="center">
				<template slot-scope="scope">
					<span v-if="scope.row.phoneNumber"
						style="font-family: Consolas, Monaco, monospace; font-size: 14px; font-weight: 400; color: #3f4043;">
						{{ scope.row.phoneNumber }}
					</span>

					<span v-else style="color: #C0C4CC; font-size: 13px;">
						无
					</span>
				</template>
			</el-table-column>


			<el-table-column label="网络地址 (IP/归属地)" min-width="200">
				<template slot-scope="scope">
					<div v-if="!scope.row.ip" style="color: #C0C4CC; font-size: 13px;">无</div>
					<div
						style="font-family: Consolas, Monaco, monospace; font-size: 14px; font-weight: 400; color: #3f4043;">
						{{ scope.row.ip }}
					</div>
					<div style="font-size: 12px; color: #909399; margin-top: 2px;">
						<i class="el-icon-location-outline"></i>
						<span v-if="scope.row.address">{{ scope.row.address }}</span>
						<span v-else style="color: #DCDFE6;">位置未知</span>
					</div>
				</template>
			</el-table-column>


			<el-table-column fixed="right" label="操作" width="90" align="center">
				<template slot-scope="scope">
					<el-button @click="querySimCard(scope.$index)" type="text" size="medium"
						style="font-weight: bold;">详情</el-button>
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		computed: {
			statList() {
				return [{
						enTitle: 'TOTAL DATA',
						cnTitle: '全部数据',
						value: this.total,
						color: '#409EFF',
						bgColor: '#f0f9ff',
						icon: 'el-icon-sunny'
					},
					{
						enTitle: 'BANNED ACCOUNTS',
						cnTitle: '封号详情',
						value: this.banedNum,
						color: '#F56C6C',
						bgColor: '#fff5f5',
						icon: 'el-icon-heavy-rain',
						action: this.handleClickAccount
					},
					{
						enTitle: 'BANNED DEVICES',
						cnTitle: '封设备详情',
						value: this.blackListTotal,
						color: '#909399',
						bgColor: '#f8f9fa',
						icon: 'el-icon-lightning',
						action: this.handleClick
					},
					{
						enTitle: 'IP BLOCKED',
						cnTitle: 'IP封禁详情',
						value: this.ipBlackTotal,
						color: '#eb2f96',
						bgColor: '#fff0f6',
						icon: 'el-icon-moon-night',
						action: this.handleClickIp
					},
					{
						enTitle: 'AI DETECTION',
						cnTitle: 'AI标记',
						value: this.whiteListUsers,
						color: '#52c41a',
						bgColor: '#f6ffed',
						icon: 'el-icon-cloudy',
						action: this.toWhitelistList
					}
				];
			}
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				showStats: false, // 统计面板状态
				showSearch: false, // 搜索面板状态
				value: '', //时间
				startTime: 0, //开始时间
				endTime: 0, //结束时间
				input1: '', //信息序号
				input2: '', //设备ID
				input3: '', //用户ID
				input4: '', //用户昵称
				input5: '', //用户手机号
				input6: '', //手机品牌
				input7: '', //IP地址
				input8: '', //IP所属地
				input9: '', //AI风控等级
				riskOptions: [{
						label: '正常',
						value: '0',
						color: '#67C23A'
					},
					{
						label: '低风险',
						value: '1',
						color: '#909399'
					},
					{
						label: '中风险',
						value: '2',
						color: '#E6A23C'
					},
					{
						label: '高风险',
						value: '3',
						color: '#F56C6C'
					}
				],
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				banedNum: 0, //封号数量
				blackListTotal: 0, //黑名单数量(被封设备)
				ipBlackTotal: 0, //Ip被封数量
				whiteListUsers: 0, //Ai标记的数量
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //用户设备指纹信息列表
			this.getOverviewQueryRes(); //风控列表页的总览查询
		},
		methods: {
			getOverviewQueryRes() {
				const requestData = {}; //传递的参数
				axios.post(this.$p_url + '/admin/getOverviewQueryRes', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						console.log("风控列表页的总览查询 后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							this.banedNum = response.data.data.banedNum; //封号数量
							this.blackListTotal = response.data.data.blackListTotal; //黑名单数量
							this.ipBlackTotal = response.data.data.ipBlackTotal; //IP封禁的数量
							this.whiteListUsers = response.data.data.whiteListUsers; //Ai标记的数量
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			fetchData(pageNum, pageSize) { //用户设备指纹信息列表

				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.input1.length > 0) { //信息序号
					requestData.sequenceId = this.input1;
				}
				if (this.input2.length > 0) { //设备id 精确查询
					requestData.deviceId = this.input2;
				}
				if (this.input3.length > 0) { //用户id 精确查询
					requestData.userId = this.input3;
				}
				if (this.input4.length > 0) { //用户名称，模糊查询
					requestData.nickName = this.input4;
				}
				if (this.input5.length > 0) { //手机号码  精确查询
					requestData.phoneNumber = this.input5;
				}
				if (this.input6.length > 0) { //手机品牌  为空时默认查全部
					requestData.brand = this.input6;
				}
				if (this.input7.length > 0) { //IP地址
					requestData.ip = this.input7;
				}
				if (this.input8.length > 0) { //IP所属地
					requestData.address = this.input8;
				}
				if (this.input9.length > 0) { //AI风控等级
					requestData.aiRiskLevel = this.input9;
				}
				if (this.startTime > 0) { //开始时间
					requestData.startTime = this.startTime;
				}
				if (this.endTime > 0) { //结束时间
					requestData.endTime = this.endTime;
				}

				axios.post(this.$p_url + '/admin/getPageOfDeviceBasicInfoNetEasy', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							const resultData = response.data.data || {}; //安全获取 data 对象
							this.total = resultData.total || 0;
							const list = resultData.list || []; //防御性获取 list，如果 list 为空则赋值为空数组 []，避免 .length 报错

							for (let i = 0; i < list.length; i++) {
								let item = list[i]; // 定义一个 item 方便书写，不用每次都写一长串

								const statusMap = {// 处理状态
									0: "正常",
									1: "禁言",
									2: "被封禁",
									3: "禁止登录",
									4: "自动封号",
									"-3": "自己注销",
									"-2": "自动封号"
								};
								if (statusMap[item.status] !== undefined) {
									item.status = statusMap[item.status];
								}
								
								const riskMap = {// 处理风险等级
									0: "正常",
									1: "低风险",
									2: "中风险",
									3: "高风险",
									4: "可信源"
								};
								if (riskMap[item.riskLevel] !== undefined) {
									item.riskLevel = riskMap[item.riskLevel];
								}
							}
							this.tableData = list;//最后赋值给表格
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			handleClick() { //被封设备

				//不打开新的标签页面
				// this.$router.push({
				// 	path: '/WindControlBlackList',
				// 	query: {}
				// });

				//打开新的标签页面
				let page = this.$router.resolve({
					path: '/WindControlBlackList',
					query: {}
				});
				window.open(page.href, '_blank');
			},
			handleClickAccount() { //被封账号

				//不打开新的标签页面
				// this.$router.push({
				// 	path: '/WindControlBanList',
				// 	query: {}
				// });

				//打开新的标签页面
				let page = this.$router.resolve({
					path: '/WindControlBanList',
					query: {}
				});
				window.open(page.href, '_blank');

			},
			handleClickIp() { //IP被封详情
				let page = this.$router.resolve({
					path: '/WindControlIp',
					query: {}
				});
				window.open(page.href, '_blank');
			},
			toWhitelistList() { //白名单
				let page = this.$router.resolve({
					path: '/WhitelistList',
					query: {}
				});
				window.open(page.href, '_blank');
			},
			querySimCard(index) { //查看详情

				//不打开新的标签页面
				// this.$router.push({
				// 	path: '/WindControlInfo',
				// 	query: {
				// 		sequenceId: this.tableData[index].sequenceId,
				// 		userId: this.tableData[index].userId,
				// 	}
				// });

				//打开新的标签页面
				if (this.tableData[index].deviceOs == "Android") {
					let page = this.$router.resolve({
						path: '/WindControlInfo',
						query: {
							sequenceId: this.tableData[index].sequenceId,
							deviceId: this.tableData[index].deviceId,
							userId: this.tableData[index].userId,
							country: this.tableData[index].country,
							id: this.tableData[index].id,
							phoneNumber: this.tableData[index].phoneNumber,
							ip: this.tableData[index].ip,
						}
					});
					window.open(page.href, '_blank');
				} else {
					let page = this.$router.resolve({
						path: '/WindControlInfo01',
						query: {
							sequenceId: this.tableData[index].sequenceId,
							deviceId: this.tableData[index].deviceId,
							userId: this.tableData[index].userId,
							country: this.tableData[index].country,
							id: this.tableData[index].id,
							phoneNumber: this.tableData[index].phoneNumber,
							ip: this.tableData[index].ip,
						}
					});
					window.open(page.href, '_blank');
				}


			},
			reset() { //单击了重置
				this.startTime = 0; //开始时间
				this.endTime = 0; //结束时间
				this.input1 = ""; //信息序号
				this.input2 = ""; //设备ID
				this.input3 = ""; //用户ID
				this.input4 = ""; //用户昵称
				this.input5 = ""; //用户手机号
				this.input6 = ""; //手机品牌
				this.input7 = ""; //IP地址
				this.input8 = ""; //IP所属地
				this.input9 = ''; //AI风控等级

				this.fetchData(1, this.pageSize);
			},
			search() { //单击了搜索
				console.log('开始时间/结束时间', this.startTime + "/" + this.endTime);
				console.log('信息序号/设备ID/用户ID/ip', this.input1 + "/" + this.input2 + "/" + this.input3 + "/" + this.input7);
				console.log('用户昵称/用户手机号/手机品牌', this.input4 + "/" + this.input5 + "/" + this.input6);
				console.log('IP所属地/AI风控等级', this.input8 + "/" + this.input9);

				this.fetchData(1, this.pageSize);
			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			formatDate(timestamp) {
				const date = new Date(timestamp);
				// 获取年月日时分秒
				const year = date.getFullYear();
				const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 补0操作
				const day = date.getDate().toString().padStart(2, '0');
				const hours = date.getHours().toString().padStart(2, '0');
				const minutes = date.getMinutes().toString().padStart(2, '0');
				const seconds = date.getSeconds().toString().padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			riskConfig(level) { // 定义配置表，方便统一维护
				const safeLevel = (level === undefined || level === null) ? 4 : level;
				//3.代表直接封禁账户+封禁该手机（模拟器）继续使用APP；2代表直接阻断，封禁该账户；1代表有风险，但是你无法判断应不应该直接封号，交给人工进行二审；0代表该用户没有风险，可以正常使用。
				const configs = {
					4: {
						type: 'info', // 使用灰色，表示非业务性风险，而是系统未抓取到
						label: '-',
						icon: 'el-icon-warning-outline' // 使用空心图标，视觉上更“轻”
					},
					3: {
						type: 'danger',
						label: '高风险',
						icon: 'el-icon-error'
					},
					2: {
						type: 'warning',
						label: '中风险',
						icon: 'el-icon-warning'
					},
					1: {
						type: 'info',
						label: '低风险',
						icon: 'el-icon-info'
					},
					0: {
						type: 'success',
						label: '正常',
						icon: 'el-icon-success'
					}
				};
				// 如果 level 不在 0-3 之间，返回兜底配置
				return configs[safeLevel] || {
					type: '',
					label: '未知状态(' + level + ')',
					icon: 'el-icon-question'
				};
			},

			getType(level) {
				return this.riskConfig(level).type;
			},
			getText(level) {
				return this.riskConfig(level).label;
			},
			getIcon(level) {
				return this.riskConfig(level).icon;
			},
			isValid(level) {
				return [0, 1, 2, 3, 4].includes(level);
			}
			//...
		},
		//...
	}
</script>

<style>
	.container {
		display: flex;
		padding: 0px 10px;
	}

	.box {
		flex: 1;
		padding: 15px;
		width: 180px;
		height: 60px;
		margin: 10px;
		border-radius: 20px;
		/* 防止文本溢出 */
		overflow: hidden;
	}
</style>